import styled from 'styled-components';

export const TermsPageContainer = styled.main`
    h3 {
        text-transform: initial;
        margin: 20px 0;
    }

    ul li,
    p {
        text-align: justify;
    }

    p {
        margin-top: 15px;
    }

    ul li {
        margin-bottom: 5px;
    }

    table {
        margin: 20px 0;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPageStyle.js